import { createAction } from 'redux-actions';
import { actionKey } from './constants';
export const requestJoinGroup = createAction(`${actionKey}.REQUEST_JOIN`, (group)=>({
        group
    }));
export const requestLeaveGroup = createAction(`${actionKey}.REQUEST_LEAVE`, (group)=>({
        group
    }));
export const groupJoinSuccess = createAction(`${actionKey}.JOIN_SUCCESS`, (group)=>({
        group
    }));
export const groupJoinFail = createAction(`${actionKey}.JOIN_FAIL`, (group, error)=>({
        group,
        error
    }));
export const groupJoinPending = createAction(`${actionKey}.JOIN_PENDING`, (group)=>({
        group
    }));
export const groupLeaveSuccess = createAction(`${actionKey}.LEAVE_SUCCESS`, (group)=>({
        group
    }));
export const groupLeaveFail = createAction(`${actionKey}.LEAVE_FAIL`, (group, error)=>({
        group
    }));
export const sendAdminNote = createAction(`${actionKey}.SEND_ADMIN_NOTE`, (recipientId, subject, editorRaw)=>({
        recipientId,
        subject,
        editorRaw
    }));
// since send_groupnote needs to be branched in multiple places, it's easier to
// branch it in a single place, behind this action
export const messageAdmins = createAction(`${actionKey}.MESSAGE_ADMINS`, (group)=>({
        group
    }));

//# sourceMappingURL=actions.js.map